import { useState } from "react";
import Modal from "../shared/Modal";
import { useSelector, useDispatch } from "react-redux";
import { selectUser } from "../../redux/features/appData/";

import "./ModalDeleteAllResourcesConfirm.css";
import { Button } from "../../ds2/components";

type ModalDeleteAllResourcesConfirmProps = {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
};

const ModalDeleteAllResourcesConfirm = ({
  isOpen,
  onClose,
  onDelete,
}: ModalDeleteAllResourcesConfirmProps) => {
  const dispatch = useDispatch();
  const storeUser = useSelector(selectUser);

  const [confirmText, setConfirmText] = useState<string>("");

  if (!isOpen) {
    return null;
  }

  const handleDelete = async () => {
    onDelete();
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={false}
        allowClickout={true}>
        <div id="modal-delete-all-resources">
          <div className="modal-delete-all-resources-title">Confirm Delete</div>

          <div className="modal-delete-all-resources-content">
            To delete all resources in this collection from Winslow AI, please
            type "DELETE" below.
          </div>

          <div className="modal-delete-all-resources-confirm">
            <input
              autoFocus={true}
              type="text"
              value={confirmText}
              onChange={(e: any) => setConfirmText(e.target.value)}
              onKeyDown={(e: any) => {
                if (
                  e.key === "Enter" &&
                  confirmText.toLowerCase() === "delete"
                ) {
                  handleDelete();
                }
              }}
            />
          </div>

          <div className="edit-tag-name-footer">
            <div className="edit-tag-name-buttons">
              <Button 
                variant="secondary"
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button
                disabled={confirmText.toLowerCase() !== "delete"}
                onClick={handleDelete}
              >
                Delete
              </Button>
              {/* <button
                disabled={confirmText.toLowerCase() !== "delete"}
                onClick={handleDelete}
                className="collections-button">
                Delete
              </button> */}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalDeleteAllResourcesConfirm;
